import { Link } from "react-router-dom";
import { ArrowUpRight, Crown, Globe2, Sparkles, Ticket, TrendingUp } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "../motion/Reveal";
import { useSite } from "../../lib/site";

const ICONS = [Globe2, TrendingUp, Ticket, Sparkles];

export const Membership = () => {
  const { content } = useSite();
  const m = content.membresia;
  return (
    <section id="membresia" className="relative overflow-hidden bg-paper py-16 sm:py-24 lg:py-28" data-testid="membresia-section">
      <div className="pointer-events-none absolute -right-40 top-10 h-[420px] w-[420px] rounded-full bg-sun/30 blur-[140px]" />
      <div className="container-x relative grid gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-5">
          <Eyebrow>{m.eyebrow}</Eyebrow>
          <MaskLines lines={[m.title]} className="h-section mt-5" testId="membresia-title" />
          <Reveal className="mt-6 text-base leading-relaxed text-ink/75 sm:text-lg">
            <p>{m.intro}</p>
          </Reveal>
          <Reveal delay={0.1} className="mt-8 inline-flex flex-col rounded-[1.75rem] border border-ink/10 bg-ink p-7 text-white" data-testid="membresia-price-card">
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 place-items-center rounded-2xl bg-sun text-ink"><Crown className="h-5 w-5" /></span>
              <span className="font-mono text-xs uppercase tracking-[0.14em] text-sun">Membresía Dorada</span>
            </div>
            <p className="mt-5 font-display text-6xl font-semibold leading-none tracking-[-0.04em]" data-testid="membresia-price">
              <span className="align-top text-2xl">$</span>{m.price}<span className="ml-2 text-xl text-[#AEB7D3]">{m.currency}</span>
            </p>
            <p className="mt-3 text-sm text-[#C9D0E4]">{m.price_note}</p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link to="/registro" className="btn-leaf group" data-testid="membresia-cta">
                {m.cta} <ArrowUpRight className="btn-arrow h-5 w-5" />
              </Link>
              <Link to="/login" className="btn-ghost-dark" data-testid="membresia-login">{m.cta_secondary}</Link>
            </div>
          </Reveal>
          <Reveal delay={0.18} className="mt-5 rounded-[1.75rem] border border-sun/70 bg-sun/15 p-6" data-testid="membresia-platforms">
            <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-[#8a6a00]">{m.platforms_eyebrow}</p>
            <h3 className="mt-2 font-display text-2xl font-semibold leading-tight tracking-tight sm:text-3xl">{m.platforms_title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink/75">{m.platforms_text}</p>
            <ul className="mt-5 grid gap-2 sm:grid-cols-3">
              {(m.platforms || []).map((p, i) => (
                <li key={p.name} className="rounded-2xl border border-ink/10 bg-white p-4" data-testid={`membresia-platform-${i}`}>
                  <p className="font-display text-sm font-semibold uppercase tracking-[0.06em] text-leaf-deep">{p.name}</p>
                  <p className="mt-1 font-display text-3xl font-semibold tracking-tight">${p.price}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.08em] text-ink/55">{m.platforms_price_note}</p>
                  <p className="mt-2 text-xs leading-relaxed text-ink/70">{p.text}</p>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-sm font-semibold text-ink" data-testid="membresia-platforms-example">{m.platforms_example}</p>
          </Reveal>
        </div>
        <div className="grid gap-3 sm:grid-cols-2 lg:col-span-7 lg:content-start lg:pt-16">
          {m.benefits.map((b, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={b.title} delay={0.08 * i} className="group rounded-[1.5rem] border border-ink/10 bg-white p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-sun" data-testid={`membresia-benefit-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="grid h-11 w-11 place-items-center rounded-2xl bg-sun/20 text-[#8a6a00] transition-colors duration-300 group-hover:bg-sun group-hover:text-ink"><Icon className="h-5 w-5" /></span>
                  <span className="font-mono text-xs text-ink/50">0{i + 1}</span>
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold leading-tight tracking-tight">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70 sm:text-base">{b.text}</p>
              </Reveal>
            );
          })}
          <Reveal className="sm:col-span-2">
            <p className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.08em] text-ink/55" data-testid="membresia-disclaimer">{m.disclaimer}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
